import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-black bg-opacity-50 h-screen w-screen flex items-center justify-center" }

import { onMounted } from "vue";
import router from "@/router";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useRoute } from "vue-router";
import { fetchConfirmEmail } from "@/api/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'VerifyEmailView',
  setup(__props) {

onMounted(async () => {
  const queryToken = route.query.token as string | null;
  const queryEmail = route.query.email as string | null;
  if (queryToken !== null && queryEmail !== null) {
    try {
      await fetchConfirmEmail(queryEmail, queryToken);
    } catch (error) {
      console.log(error);
    }
  }
  await router.replace({ name: ROUTE_NAMES.HOME });
});

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", {
      class: "align-[-0.125em] animate-spin border-4 border-current border-e-transparent border-solid h-8 w-8 rounded-full text-white",
      role: "status"
    }, null, -1)
  ]))]))
}
}

})